export const financings = {
    layout: {
        listTitle: 'Financiamentos',
        listTitleLoan: 'Empréstimos',
        detailTitle: 'Financiamento',
        detailTitleLoan: 'Empréstimo',
        formTitle: 'Novo Financiamento',
    },
    list: {
        summary: {
            activeLabel: 'Ativos',
            monthlyCommitmentLabel: 'Compromisso mensal',
        },
        status: {
            settled: 'Quitado',
            archived: 'Arquivado',
        },
        noInstitution: 'Sem instituição',
        nextInstallment: 'Parcela #{{number}}',
        nextInstallmentWithDue: 'Parcela #{{number}} · vence {{date}}',
        noPendingInstallments: 'Sem parcelas pendentes',
        amountPerMonth: '{{amount}}/mês',
        remainingCount_one: '{{count}} restante',
        remainingCount_other: '{{count}} restantes',
        installmentCount_one: '{{count}} parcela',
        installmentCount_other: '{{count}} parcelas',
        emptyTitle: 'Nenhum financiamento ativo',
        emptySubtitle: 'Cadastre um contrato para acompanhar parcelas e abatimentos no fluxo normal do app.',
        emptyAction: 'Novo financiamento',
        emptyTitleLoan: 'Nenhum empréstimo ativo',
        emptySubtitleLoan: 'Empréstimo do banco ou da fintech: acompanhe as parcelas, pague em partes e lance juros por atraso.',
        emptyActionLoan: 'Novo empréstimo',
        endedSection: 'Encerrados',
    },
    detail: {
        monthlyInstallmentLabel: 'Parcela mensal',
        remainingLabel: 'Restantes',
        progressPaid: '{{paid}} de {{total}} pagas',
        // Cabeçalho escuro do redesign
        balanceHeroLabel: 'Saldo devedor hoje',
        // Só para o snapshot parado. "hoje" num número do dia do cadastro fazia a pessoa
        // achar que o app não estava abatendo o que ela pagou.
        balanceHeroInformedLabel: 'Saldo devedor informado',
        balanceHeroFallbackLabel: 'Falta pagar em parcelas',
        balanceUpdatedShort: 'em {{date}}',
        balanceHeroSplitHint: 'da próxima parcela de {{installment}}, {{amortization}} abatem a dívida — o resto é juro do mês',
        // Contrato sem taxa (ADR 0129): o topo é o que falta em parcelas, e o saldo que a
        // pessoa digitou desce para uma linha secundária, com a data. O ⓘ diz o caminho.
        balanceInformedLine: 'Saldo informado: {{value}} em {{date}}',
        balanceInformedLineNoDate: 'Saldo informado: {{value}}',
        balanceHeroMissingRateHint: 'Sem a taxa do contrato o app não calcula o saldo devedor. Informe a taxa em Editar contrato → Cálculo → Price ou SAC para o saldo descer a cada parcela.',
        payingWith: 'debita no {{account}}',
        rulerPaid_one: '{{count}} paga',
        rulerPaid_other: '{{count}} pagas',
        rulerRemaining_one: '{{count}} restante',
        rulerRemaining_other: '{{count}} restantes',
        rulerRemainingUntil: '{{remaining}} · até {{date}}',
        // Cartão da próxima parcela
        nextInstallmentOf: 'Parcela {{number}} de {{total}}',
        dueToday: 'vence hoje',
        dueInDays_one: 'vence em {{count}} dia',
        dueInDays_other: 'vence em {{count}} dias',
        overdueDays_one: 'atrasada há {{count}} dia',
        overdueDays_other: 'atrasada há {{count}} dias',
        payButton: 'Pagar',
        paidShortLabel: 'Já pago',
        interestShortLabel: 'Juros previstos',
        amortizationShortLabel: 'Abate a dívida',
        prepaymentShortLabel: 'Abater',
        // Grupos da lista
        groupUpcoming: 'A vencer',
        groupPaid: 'Pagas',
        paidSoFarLabel: 'Pago até agora',
        pendingAmountLabel: 'A pagar em parcelas',
        nextInstallment: 'Próxima parcela: {{number}}',
        nextInstallmentWithDue: 'Próxima parcela: {{number}} · vence {{date}}',
        outstandingBalance: 'Saldo devedor: {{balance}}',
        outstandingBalanceWithDate: 'Saldo devedor: {{balance}} · atualizado em {{date}}',
        estimatedInterest: 'Juros estimados no cronograma: {{amount}}',
        recordPrepaymentButton: 'Registrar abatimento',
        allInstallmentsPaidHint: 'Todas as parcelas foram pagas — não há nada para abater.',
        transactionsSection: 'Lançamentos',
        pendingCount_one: '{{count}} pendente',
        pendingCount_other: '{{count}} pendentes',
        confirmedCount_one: '{{count}} concluída',
        confirmedCount_other: '{{count}} concluídas',
        numberingNote: 'A numeração segue o contrato original ({{total}}x); abatimentos removem as últimas parcelas.',
        // No empréstimo o abatimento também pode abater da próxima (ADR 0057), então
        // "removem as últimas" deixaria de descrever a série que a pessoa está vendo.
        numberingNoteLoan: 'A numeração segue o contrato original ({{total}}x); abatimentos removem parcelas da série.',
        emptyTitle: 'Nenhum lançamento deste contrato',
        emptySubtitle: 'As parcelas regulares e os abatimentos aparecem aqui.',
        adjustments: {
            title: 'Histórico de abatimentos',
            empty: 'Nenhum abatimento registrado ainda.',
            remainingInstallments_one: '{{count}} parcela restante',
            remainingInstallments_other: '{{count}} parcelas restantes',
            balance: 'Saldo: {{balance}}',
            deleteA11y: 'Excluir abatimento de {{date}}',
        },
    },
    partialPayment: {
        alreadyPaidNote: '{{amount}} já pagos nesta parcela',
        deleteTitle: 'Excluir pagamento parcial',
        deleteMessage: 'Os {{amount}} voltam a ser cobrados na parcela em aberto.',
        deleteConfirm: 'Excluir',
    },
    charges: {
        amountLabel: 'Juros e multa',
        helper: 'Total de encargos desta parcela. Zerar volta ao valor de contrato.',
        baseLabel: 'Valor da parcela',
        alreadyPaidLabel: 'Já pago nela',
        newTotalLabel: 'Passa a cobrar',
        confirmButton: 'Salvar encargos',
        includedNote: 'inclui {{amount}} de encargos',
    },
    prepayment: {
        confirmButton: 'Confirmar abatimento',
        amountLabel: 'Valor pago',
        subtitle: '{{name}} · pagamento extra para abater o saldo devedor',
        datePlaceholder: 'Data',
        dateHelper: 'Data do pagamento extra',
        modeTerm: 'Reduzir prazo',
        modeInstallment: 'Reduzir parcela',
        modeAdvance: 'Abater da próxima',
        modeTermHelper: 'Remove as últimas parcelas; o valor mensal não muda.',
        modeInstallmentHelper: 'Diminui o valor das parcelas pendentes; o prazo não muda.',
        modeAdvanceHelper: 'Cobre a próxima parcela e segue para as seguintes se sobrar; as demais mantêm o valor combinado.',
        advanceLabel: 'O que este pagamento cobre',
        advanceHintEmpty: 'Informe o valor pago para ver quais parcelas ele cobre.',
        advanceHintSettled_one: 'Quita a próxima parcela.',
        advanceHintSettled_other: 'Quita as {{count}} próximas parcelas.',
        advanceHintPartial: 'A próxima parcela cai para {{amount}}.',
        advanceHintSettledAndPartial_one: 'Quita a próxima parcela; a seguinte cai para {{amount}}.',
        advanceHintSettledAndPartial_other: 'Quita as {{count}} próximas parcelas; a seguinte cai para {{amount}}.',
        advanceHintExceeds: 'Passa do total pendente ({{total}}) — para quitar o contrato, use o pagamento das parcelas.',
        advanceNoteSettled_one: '1 parcela quitada pelo adiantamento',
        advanceNoteSettled_other: '{{count}} parcelas quitadas pelo adiantamento',
        advanceNotePartial: 'parcela #{{number}} reduzida para {{amount}}',
        remainingLabel: 'Parcelas restantes',
        remainingHintEmpty: 'Informe quantas parcelas restam após o abatimento (hoje: {{current}})',
        installmentsRemoved_one: 'A última parcela será removida',
        installmentsRemoved_other: 'As últimas {{count}} parcelas serão removidas',
        noneRemoved: 'Nenhuma parcela será removida',
        moreThanCurrent: 'Maior que as {{total}} parcelas atuais',
        useSuggestionRemaining: 'Usar sugestão: {{value}} (valor pago ÷ parcela)',
        newMonthlyAmountLabel: 'Novo valor da parcela',
        newMonthlyAmountHelper: 'Vale para as {{total}} parcelas pendentes (hoje: {{amount}}).',
        useSuggestionAmount: 'Usar sugestão: {{value}} (saldo restante ÷ parcelas)',
        newBalanceLabel: 'Novo saldo devedor',
        balanceHelperKnown: 'Calculado: saldo atual ({{balance}}) − valor pago. Ajuste se o banco informar outro.',
        balanceHelperEstimated: 'Calculado: parcelas pendentes ({{balance}}) − valor pago, sem desconto de juros. Ajuste pro valor do banco.',
        balanceHelperEmpty: 'Saldo que falta pagar após o abatimento, conforme o banco.',
        withoutCashLabel: 'Sem movimentar conta',
        withoutCashHelper: 'Pago com FGTS ou outro recurso fora do app — entra só no histórico do contrato, sem debitar nenhuma conta.',
        notesPlaceholder: 'Observação (opcional)',
    },
    edit: {
        recalibrateTitle: 'Ajustar projeção ao boleto',
        recalibrateMessage: 'A parcela {{number}} foi prevista em {{expected}} e o boleto veio {{observed}}. Aplicar a diferença de {{diff}} às parcelas futuras como seguros e taxas?',
        recalibrateConfirm: 'Ajustar projeção',
        recalibrateAction: 'Ajustar projeção ao valor real',
    },
    menu: {
        editContract: 'Editar contrato',
        archiveSettle: 'Arquivar/Quitar',
        delete: 'Excluir contrato',
    },
    deleteAdjustmentDialog: {
        title: 'Excluir abatimento',
        message: 'Remove o pagamento extra de {{amount}} e devolve ao cronograma as parcelas que ele tinha removido. O saldo devedor volta ao do abatimento anterior (ou fica vazio) e o saldo da conta é recalculado.',
        confirm: 'Excluir abatimento',
    },
    deleteDialog: {
        title: 'Excluir contrato',
        message: 'Apaga o contrato, TODAS as parcelas (inclusive as já pagas) e os abatimentos. Os saldos das contas são recalculados. Essa ação não pode ser desfeita. Se quiser só encerrar o acompanhamento mantendo o histórico, use Arquivar/Quitar.',
        confirm: 'Excluir tudo',
    },
    archiveDialog: {
        title: 'Arquivar contrato',
        message: 'As parcelas futuras pendentes serão removidas do fluxo normal do app. Deseja continuar?',
        confirm: 'Arquivar',
    },
    pdf: {
        title: 'Financiamento — {{name}}',
        titleLoan: 'Empréstimo — {{name}}',
        monthlyAmountLabel: 'Parcela mensal',
        progressLabel: 'Parcelas pagas',
        progressValue: '{{paid}} de {{total}}',
        paidAmountLabel: 'Pago até agora',
        pendingAmountLabel: 'A pagar em parcelas',
        outstandingBalanceLabel: 'Saldo devedor',
        // Quando o topo da tela não é o saldo devedor (contrato sem taxa, ADR 0129), o PDF
        // chama o número gravado pelo que ele é.
        outstandingBalanceInformedLabel: 'Saldo devedor informado',
        balanceUpdatedAt: 'atualizado em {{date}}',
        installmentsSection: 'Parcelas',
        adjustmentsSection: 'Abatimentos',
        partialPaymentsSection: 'Pagamentos parciais',
        colNumber: 'Nº',
        colDate: 'Data',
        colAmount: 'Valor',
        colStatus: 'Status',
        colInstallment: 'Parcela',
        colRemaining: 'Restantes',
        colBalanceAfter: 'Novo saldo',
        statusPaid: 'Paga',
        statusPending: 'Pendente',
        noInstallments: 'Sem parcelas registradas.',
        noAdjustments: 'Nenhum abatimento registrado.',
        noPartialPayments: 'Nenhum pagamento parcial registrado.',
        exportError: 'Não foi possível gerar o PDF.',
    },
};
